/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable @typescript-eslint/ban-ts-comment */
/* eslint-disable @typescript-eslint/naming-convention */
import React, { useEffect } from 'react'
import { useSearchParams } from 'react-router-dom'
import { useMediaQueries } from 'builder/hooks/useMediaQueries'
import { TabItem } from './styles'
import CategoryDrawer from './components/CategoryDrawer'
import CategogryDropdown from './components/CategoryDropdown'
import CategoryTabsList from './components/CategoryTabList'

type ContextProps = {
  activeTab: CategoryIds
  setActiveTab: (tab: CategoryIds) => void
}

const Context = React.createContext({} as ContextProps)

export function useCategoryTabsContext() {
  const context = React.useContext(Context)
  if (!context) {
    throw new Error('useCategoryTabsContext must be used within a CategoryTabsProvider')
  }
  return context
}

export type CategoryIds = 'resumes' | 'jobs' | 'interviews' | 'careers'
export const DEFAULT_ACTIVE_TAB: CategoryIds = 'resumes'

export default function CategoryTabs(props: {
  children: React.ReactNode
  defaultActive?: CategoryIds
}) {
  const [searchParams, setSearchParams] = useSearchParams()
  const urlTab = searchParams.get('categoryTab') as CategoryIds | null

  const initialTab = urlTab ?? props.defaultActive ?? DEFAULT_ACTIVE_TAB
  const [activeTab, setActiveTab] = React.useState<CategoryIds>(initialTab)

  useEffect(() => {
    const next = new URLSearchParams(searchParams)
    next.set('categoryTab', activeTab)
    setSearchParams(next)
  }, [activeTab, searchParams])

  return <Context.Provider value={{ activeTab, setActiveTab }}>{props.children}</Context.Provider>
}

const List = ({ children }: { children: React.ReactNode }) => {
  const { isTablet, isLaptop, isPhone } = useMediaQueries()
  const childArray = React.Children.toArray(children)

  const items = childArray
    .filter(React.isValidElement<{ tabId: CategoryIds; children: React.ReactNode }>)
    .map(el => ({
      id: el.props.tabId,
      label: typeof el.props.children === 'string' ? el.props.children : String(el.props.children),
      element: el,
    }))

  if (isPhone) {
    return <CategoryDrawer items={items} />
  }

  if (isTablet || isLaptop) {
    return <CategogryDropdown items={items} />
  }

  return <CategoryTabsList items={items} />
}

const Item = (props: { children: React.ReactNode; tabId: CategoryIds }) => {
  const { activeTab, setActiveTab } = useCategoryTabsContext()

  return (
    <TabItem isActive={activeTab === props.tabId} onClick={() => setActiveTab(props.tabId)}>
      {props.children}
    </TabItem>
  )
}

const Content = (props: { children: React.ReactNode; tabId: CategoryIds }) => {
  const { activeTab } = useCategoryTabsContext()

  if (activeTab !== props.tabId) return null

  return (
    <div
      style={{
        display: 'flex',
        justifyContent: 'center',
      }}
      id={`${props.tabId}-content`}
    >
      {props.children}
    </div>
  )
}

CategoryTabs.List = React.memo(List)
CategoryTabs.Item = React.memo(Item)
CategoryTabs.Content = React.memo(Content)
